import { render, staticRenderFns } from "./RobotsIndex.vue?vue&type=template&id=5fe6b154"
import script from "./RobotsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RobotsIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports